import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import LiderRegistro from "components/logins/liderRegistro";
const ModalRegistro = ({ show, handleClose, tabla }) => {
  return (
    <Modal show={show} fullscreen={true} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Registro Lider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LiderRegistro Isadmin={true} close={handleClose} tabla={tabla} />
     
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {/* <Button variant="dark">jfgg</Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRegistro;
